import { connect } from 'react-redux'
import SentimentPanel from './SentimentPanel'

const mapStateToProps = ({ media: { transcription } }) => transcription

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(SentimentPanel)
